import { DiscordButton } from "./buttons/Discord";
import { LemmyButton } from "./buttons/Lemmy";
import { MailingListsButton } from "./buttons/MailingLists";
import { MastodonButton } from "./buttons/Mastodon";
import { MatrixButton } from "./buttons/Matrix";
import { TipButton } from "./buttons/Tip";

export const InfoButtons = () => {
  return (
    <div className="p-2 flex gap-2 flex-wrap">
      <MatrixButton />
      <DiscordButton />
      <LemmyButton />
      <MastodonButton />
      <TipButton />
      <MailingListsButton />
    </div>
  );
};
